import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';
import HunterLayout from '../components/Layout/HunterLayout';
import { useEffect } from 'react';
import { useAppDispatch } from '../types/hooks';
import { log } from '../store/actions/logActions';

const ErrorBoundary = () => {
    const { t } = useTranslation();
    const error = useRouteError();
    const d = useAppDispatch();

    useEffect(() => {
        d(
            log({
                method: 'ErrorBoundaries',
                error: JSON.stringify(error),
            }),
        );
    }, [error]);

    return (
        <HunterLayout>
            <div className="error-boundary-container">
                <h1 className="error-boundary-title">{t('web.error.somethingWentWrong')}</h1>
                <h3 className="mt-3 error-boundary-description">{t('web.error.description')}</h3>
            </div>
        </HunterLayout>
    );
};

export default ErrorBoundary;
